import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Star } from 'lucide-react';
import { testimonials, successPhotos } from '../data/mock';

const TestimonialsPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Geslaagd!</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Trots op al onze geslaagde leerlingen! Bekijk hun ervaringen en succesverhalen.
          </p>
        </div>
      </section>

      {/* Success Photos Gallery */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Onze Geslaagde Leerlingen</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {successPhotos.map((photo, index) => (
              <div 
                key={index} 
                className="aspect-square rounded-lg overflow-hidden cursor-pointer hover:opacity-90 transition-opacity shadow-lg hover:shadow-xl"
                onClick={() => setSelectedImage(photo)}
              >
                <img
                  src={photo}
                  alt={`Geslaagde leerling ${index + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="max-w-4xl max-h-[90vh]">
            <img
              src={selectedImage}
              alt="Geslaagde leerling"
              className="w-full h-full object-contain rounded-lg"
            />
          </div>
          <button 
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300"
            onClick={() => setSelectedImage(null)}
          >
            ×
          </button>
        </div>
      )}

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Wat onze leerlingen zeggen</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <Card key={testimonial.id} className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-6">
                  <div className="flex items-center mb-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-16 h-16 rounded-full object-cover mr-4"
                    />
                    <div>
                      <div className="font-semibold text-gray-900 text-lg">{testimonial.name}</div>
                      <div className="flex mt-1">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-600 italic leading-relaxed mb-4">"{testimonial.text}"</p>
                  <p className="text-sm text-gray-500">{testimonial.date}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      {/* <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">500+</div>
              <div className="text-blue-100 text-lg">Geslaagde Leerlingen</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">95%</div>
              <div className="text-blue-100 text-lg">Slagingspercentage</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">4.9</div>
              <div className="text-blue-100 text-lg">Gemiddelde Beoordeling</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">15+</div>
              <div className="text-blue-100 text-lg">Jaar Ervaring</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Jij ook binnenkort geslaagd?</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Word onderdeel van onze succesverhalen! Start vandaag nog met je rijlessen.
          </p>
          <a href="/contact">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors">
              Plan je Proefles met 30% Korting
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default TestimonialsPage;